module.exports = __webpack_public_path__ + "static/media/adedipe1.80c1e617.png";